module.exports = __webpack_public_path__ + "static/media/ios-mock.789e2368.svg";